module.exports = __webpack_public_path__ + "img/1-bg.cc5c70c1.png";